<template>
    <div :style="{'min-height':minHeight}" style="background-color: rgba(0,0,0,0.05);display:flex;flex-direction: column;align-items: center;justify-content: flex-start;width:100%;height:100%;">
        <!-- 轮播图 -->
        <!-- <div style="width:100%;display: none;">
            <el-carousel :interval="4000" type="card"  :height="computeHeight">
                <el-carousel-item v-for="(item, index) in sliders" :key="index">
                    <img :src="item.img" class="slider_img">
                </el-carousel-item>
            </el-carousel>        
        </div> -->
        <div style="width:1200px;margin: 50px 0 30px 0;display:flex;justify-content: space-between;">
            <!-- 学院简介 -->
            <!-- <div style="width:100%;display: flex;flex-direction: column;align-items: center;margin-bottom: 100px;">
                <div style="position: relative;height: 120px;">
                    <div style="width:100%;heigth:120px;line-height: 100px;text-align: center;font-size:32px;color:rgba(0,0,0,0.8);">学院简介</div>
                    <div style="position: absolute;left: 50%;bottom: 20px;margin-left: -40px;width: 80px;height: 3px;background-color: rgba(0,0,0,0.1);"></div>
                </div>
                <div style="margin-top:30px;width:960px;line-height:30px;padding: 0 10px 0 15px;font-size: 14px;color:#666666;">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;西安美术学院建校于1949年，其前身为西北人民艺术学院二分部，1949年7月由山西临汾迁至西安市长安县，更名为西北军政大学艺术学院，后历经西北艺术专科学校、西北美术专科学校等阶段，于1960年5月正式定名为西安美术学院，1994年学院整体迁至西安市雁塔区含光路南段。

    西安美术学院自建校以来，广纳贤才、汇聚名师，立足卓绝的延安精神和厚重的历史文化传统，传承红色基因，形成了独具特色的艺术教育理念，为国家的建设发展培养了大批优秀艺术人才，创作了许多在中国当代美术史上具有深远影响的作品，为繁荣社会主义艺术事业做出了重要贡献，产生了良好的社会声誉和影响。改革开放以来，西安美术学院以育人为根本、以教学为中心、以教师为主体、以质量为生命、以繁荣文化为己任、秉承“艰苦创业，追求卓越”的精神，恪守“弘美厚德，借古开今”的校训，发挥地域优势，突出西部特色，率先将书法和民间美术纳入课堂教学，长期坚持并重视周秦汉唐历史文化、延安革命文艺、西北民族民间艺术、当代“长安画派”与“黄土画派”四大传统和绘画、书法、美术史论、中国民间美术“四大基础”教学，逐渐形成了基础雄厚、结构合理、特色鲜明的美术教育体系。
                </div>
            </div> -->
            <!-- 公告 -->

            <div style="width:393px;height:400px;background-color:#fff;border-radius: 5px;box-sizing: border-box;padding:5px;overflow-y: auto;">
                <table border="0"  style="border-style: none;border-color:#dddddd;text-align: center; width: 100%; border-collapse: collapse;">
                    <tr style="height: 40px;">
                        <td colspan="2">
                            <div style="display:flex;border-bottom: 1px dashed #c40001;justify-content: flex-start;align-items: center;">
                                <img src="../../static/other/ios-volume-high.png" style="width:20px;heigth:20px;">            
                                <div style="font-size:20px;color:#c40001;font-weight: bolder;height: 40px;line-height: 40px;margin-left:10px;">
                                    招聘公告
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="newsList.length>0" @click="goNews(item.id)" v-for="item in newsList"  style="cursor: pointer;height: 40px;color:#888888;font-size:14px;font-weight: 400;">
                        <td>
                            <div style="display:flex;justify-content: flex-start;align-items: center;">
                                <img src="../../static/other/ios-volume-sm.png" style="width:16px;heigth:16px;">            
                                <div style="font-size:14px;height: 30px;line-height: 30px;margin-left:10px; ">
                                    {{item.newsTitle.length>20?item.newsTitle.substring(0,20)+'...':item.newsTitle}}
                                </div>
                            </div>
                        </td>
                        <td style="text-align: right;">
                            {{item.createTime.substring(0,10)}}
                        </td>
                    </tr>
                </table>
            </div>  
            <div style="width:393px;height:400px;background-color:#fff;border-radius: 5px;box-sizing: border-box;padding:5px;overflow-y: auto;display: flex;flex-direction: column;justify-content: space-between;">
                <table border="0"  style="border-style: none;border-color:#dddddd;text-align: center; width: 100%; border-collapse: collapse;">
                    
                    <tr style="height: 40px;">
                        <td colspan="4">
                            <div style="display:flex;border-bottom: 1px dashed #c40001;justify-content: flex-start;align-items: center;">
                                <img src="../../static/other/ios-people.png" style="width:20px;heigth:20px;">            
                                <div style="font-size:20px;color:#c40001;font-weight: bolder;height: 40px;line-height: 40px;margin-left:10px;">
                                    最新岗位
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr style="font-size:13px;font-weight: bold;height:30px;line-height: 30px;color:#888888;">
                        <td style="width:100px;text-align: center;">岗位名称</td>
                        <td style="width:120px;text-align: center;">岗位类别</td>
                        <td style="width:60px;text-align: center;">招聘人数</td>
                        <td style="text-align: center;">发布日期</td>
                    </tr>
                    <tr v-if="jobPublishList.length>0" @click="goJob(item.id,item.jobId)" v-for="item in jobPublishList"  style="cursor: pointer;height: 40px;color:#888888;font-size:14px;font-weight: 400;">
                        <td>
                            <div style="display:flex;justify-content: flex-start;align-items: center;">
                                <img src="../../static/other/ios-people-sm.png" style="width:16px;heigth:16px;">            
                                <div style="font-size:14px;height: 30px;line-height: 30px;margin-left:10px;display: flex;">
                                    <div style="overflow: hidden;text-align: left;">{{item.childDeptName}}</div>
                                </div>
                            </div>
                        </td>
                        <td style="text-align: center;overflow: hidden;">
                            {{item.majorName}}
                        </td>
                        <td style="text-align: center;">
                            {{item.needNumber}}
                        </td>
                        <td style="text-align: center;overflow: hidden;">
                            {{item.createTime.substring(0,10)}}
                        </td>
                    </tr>                    
                </table>
                <div style="width:100%;height: 30px;line-height: 30px;text-align: left;color:#666666;font-size: 14px;">
                    查看更多招聘信息请点击<span style="color:333333;font-weight: bolder;">招聘岗位</span>
                </div>
            </div>                        
            <div style="width:393px;height:400px;background-color:#fff;border-radius: 5px;box-sizing: border-box;padding:5px;overflow-y: auto;display: flex;flex-direction: column;justify-content: space-between;">
                <table border="0"  style="border-style: none;border-color:#dddddd;text-align: center; width: 100%; border-collapse: collapse;">
                    
                    <tr style="height: 40px;">
                        <td colspan="4">
                            <div style="display:flex;border-bottom: 1px dashed #c40001;justify-content: flex-start;align-items: center;">
                                <img src="../../static/other/ios-people.png" style="width:20px;heigth:20px;">            
                                <div style="font-size:20px;color:#c40001;font-weight: bolder;height: 40px;line-height: 40px;margin-left:10px;">
                                    博士常年招聘岗位
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr style="font-size:13px;font-weight: bold;height:30px;line-height: 30px;color:#888888;">
                        <td style="width:100px;text-align: center;">岗位名称</td>
                        <td style="width:120px;text-align: center;">岗位类别</td>
                        <td style="width:60px;text-align: center;">招聘人数</td>
                        <td style="text-align: center;">发布日期</td>
                    </tr>
                    <tr v-if="boshiList.length>0" @click="goJob(item.id,item.jobId)" v-for="item in boshiList"  style="cursor: pointer;height: 40px;color:#888888;font-size:14px;font-weight: 400;">
                        <td>
                            <div style="display:flex;justify-content: flex-start;align-items: center;">
                                <img src="../../static/other/ios-people-sm.png" style="width:16px;heigth:16px;">            
                                <div style="font-size:14px;height: 30px;line-height: 30px;margin-left:10px;display: flex;">
                                    <div style="overflow: hidden;text-align: left;">{{item.childDeptName}}</div>
                                </div>
                            </div>
                        </td>
                        <td style="text-align: center;overflow: hidden;">
                            {{item.majorName}}
                        </td>
                        <td style="text-align: center;">
                            {{item.needNumber}}
                        </td>
                        <td style="text-align: center;overflow: hidden;">
                            {{item.createTime.substring(0,10)}}
                        </td>
                    </tr>                    
                </table>
                <div style="width:100%;height: 30px;line-height: 30px;text-align: left;color:#666666;font-size: 14px;">
                    查看更多招聘信息请点击<span style="color:333333;font-weight: bolder;">博士常年招聘</span>
                </div>


            </div>           
        
        </div>
        <div style="width:1200px;text-align: left;margin:30px 0 30px 0;">
            <div style="height: 40px;line-height: 40px;border-bottom: 2px dotted #c40001;width:100%;font-size:20px;color:#c40001;font-weight: bolder;">应聘步骤</div>
            <div style="width:100%;line-height: 25px;font-size: 14px;color:#666666;margin-top:10px;font-weight: bold;">
            第一步：认真阅读应聘须知；<br>
            第二步：注册账号，完善个人信息以及上传简历等附件；<br>
            第三步：选岗；<br>
            </div>
        </div>
        <!-- <div style="background-color: rgba(0, 0, 0, 0);width:100%;"> -->
        <!-- 岗位 -->
        <!-- <div  id="job"  style="width:100%;display: flex;flex-direction: column;align-items: center;margin-bottom: 50px;">
            <div style="position: relative;height: 120px;margin-top:20px;">
                <div style="width:100%;heigth:120px;line-height: 100px;text-align: center;font-size:32px;color:rgba(0,0,0,0.8);">岗位招聘</div>
                <div style="position: absolute;left: 50%;bottom: 20px;margin-left: -40px;width: 80px;height: 3px;background-color: rgba(0,0,0,0.1);"></div>
            </div>
            <el-empty v-if="jobPublishList.length==0" description="还未发布任何岗位"></el-empty>
            <div v-else style="font-size:15px;color:#fff;width:1200px;margin-top: 50px;display:flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;box-sizing: border-box;padding: 0 100px 0 100px;">          
                <div @click="goJob(item.deptId)" v-for="item in jobPublishList" style="border-radius: 20px;background-color: rgb(230, 162, 60);;cursor: pointer;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);margin:0 50px 50px 0;width:200px;height:130px;display:flex;flex-direction: column;align-items: center;justify-content: space-between;">
                    <div style="margin-top: 10px;line-height: 50px;height: 50px;font-size: 16px;font-weight: bolder;color:#eeeeee;">{{item.deptName}}</div>
                    <div style="width:100%;font-size: 13px;padding: 0 20px;box-sizing: border-box;display: flex;align-items: center;justify-content: space-between;">
                        <div>共<span style="font-size: 24px;">{{item.count}}</span>职位</div> 
                        <div><span style="font-size:24px;">{{item.number}}</span>人</div>
                    </div>
                    
                    <div style="padding: 6px 0;width:100%;text-align: center;font-size:12px;border-top: 1px dotted #ccc;color:#ccc;font-weight: bold;">{{ item.deptTypeName }}》{{item.parentDeptName}}</div>

                </div>              

            </div>
        </div>
        </div> -->
    </div>
</template>
<script>
    
    export default {
        props:['selectJob'],
        name: 'Index',
        data() {
            return {                
                sliders: [],
                newsList:[],
                jobPublishList:[],
                boshiList:[],
                minHeight:'100%',

            }
        },
        methods: {
            goJob:function(publishId,jobId){
                this.$router.push({name:'Job',query:{jobId:jobId,publishId:publishId}});
            },
            getDataList(){
                var that=this;
                this.$axios.get(this.Global.globalUrl+'/interface/getIndex.ashx')
                .then((res) => {
                    that.newsList = res.data.newsList;
                    that.jobPublishList=res.data.jobPublishList;  
                    that.boshiList=res.data.boshiList;                   
                })
                .catch(() => {
                })

            },
            goNews(newsId){
                this.$router.push({name:'PreviewFile',query:{newsId:newsId}});
            }
        },
        created(){

            this.sliders = [
                    // {
                    //     img: require("../../static/slider/header1-bg.jpg")
                    // },
                    // {
                    //     img: require("../../static/slider/header2-bg.jpg")
                    // },
                    // {
                    //     img: require('../../static/slider/header3-bg.jpg')
                    // }

                ];

        },

        mounted() {
            this.$nextTick(function () {
                this.getDataList();  

                this.minHeight = (document.documentElement.clientHeight -200)+'px';

                if (this.selectJob=='1'){
                //定位到岗位招聘锚点
                document.documentElement .scrollTop = document.getElementById('job').getBoundingClientRect().top;
                }            
            })
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenWidth = document.body.clientWidth;
                if (screenWidth > 415) {
                    return '500px';
                } else {
                    return '160px';
                }
            },
            computeArrowImg() {
                let screenWidth = document.body.clientWidth;
                if (screenWidth > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
    }
</script>

<style scoped>
    .border_parent {
        width: 90%;
        margin: auto;
    }

    .slider_img {
        height: 100%;
        width: 100%;
    }

    .el-col {
    border-radius: 4px;
  }
  .grid-content {
    width:220px;
    height:160px;
    background-color: #fff;
    margin-bottom: 20px;
    min-height: 36px;
    color:#333;
    font-size: 17px;
    text-align: center;   
    border-radius: 10px;
  }
</style>